import { SubstrateSearchScenario } from "../data/schema/SubstrateSearchScenario";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { getHasArchive } from "owa-session-store";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

/**
 * Helper function to return "X-Client-Flights" header value to compose with
 * server flights
 */
export default function getXClientFlightsHeaderValue(scenarioId: SubstrateSearchScenario, isRecursiveSearch?: boolean, isCalendarSuggestionRequest?: boolean, includePersonalizedSpellerExtension: boolean = true): string | undefined {
    if (scenarioId !== SubstrateSearchScenario.Mail &&
        !(scenarioId === SubstrateSearchScenario.Calendar && isCalendarSuggestionRequest)) {
        return undefined;
    }
    
    const flightNames: string[] = ["OWA_BestMatch_V15"];
    flightNames.push("CalendarInsightsFlight");
    
    if (getHasArchive(getGlobalSettingsAccountMailboxInfo())) {
        flightNames.push("OWA_HasArchiveMailbox");
    }
    
    const tidbitsSearchFlights = [
        "EESForEmailConv",
        "EESForEmailConvSsa",
        "EnableTidBits",
        "EnableTidBits2",
        "PopulateTidBits",
        "PopulateTidBits2",
    ];
    
    for (const tidbitFlight of tidbitsSearchFlights) {
        flightNames.push(tidbitFlight);
    }
    
    if (isRecursiveSearch) {
        flightNames.push("DisableAncestorContainerIDOnlyValidation");
    }
    
    // Move this flight to the service after the experiment succeeds.
    if (includePersonalizedSpellerExtension &&
        isGlobalFeatureEnabled("sea-personalizedSpellerExtension")) {
        flightNames.push("PersonalizedWordColon");
    }
    
    if (isGlobalFeatureEnabled("sea-searchPlusChat-hydratedAndPlainPromptSuggestions")) {
        flightNames.push("enablePromptAutoSuggestProvider", "enablePASForOwaC", "EnableHydratedPromptsOutlookQF");
    }
    else if (isGlobalFeatureEnabled("sea-searchPlusChat-plainPromptSuggestionsOnly")) {
        flightNames.push("enablePromptAutoSuggestProvider", "enablePASForOwaC");
    }
    
    return flightNames.length > 0 ? flightNames.join(",") : undefined;
}
